import Env from '../../base/env';
import Channels from '../../base/channels';
import Component from 'gia/Component';
import gsap from 'gsap';
import easesCustom from '../../fx/CustomEases';
import { ScrollTrigger } from '../../vendor/gsap-bonus-umd/ScrollTrigger';
import { SplitText } from '../../vendor/gsap-bonus-umd/SplitText';
gsap.registerPlugin(ScrollTrigger,SplitText);

export default class Module extends Component
{
  mount() {
    this.DOM = {}
    this.DOM.view = this.element
    this.DOM.button = this.DOM.view.querySelector('.jsTitle')
    this.DOM.separatorTitle = this.DOM.view.querySelector('.fxSeparatorTitle')
    this.DOM.text = this.DOM.view.querySelector('.fxText')
    this.DOM.desc = this.DOM.view.querySelector('.fxDesc')
    this.DOM.separatorH = this.DOM.view.querySelectorAll('.fxSeparatorH')
    this.DOM.separatorV = this.DOM.view.querySelectorAll('.fxSeparatorV')
    this.DOM.fade = this.DOM.view.querySelectorAll('.fxFade')
    //
    this.VARS = {}
    this.VARS.heightClose = (Env.mobileCSS)?85:170
    this.VARS.status = false
    this.VARS.IS_OPENED = false
    //
    this.FX = {}
    this.FX.textIn = new SplitText(this.DOM.button.querySelector('.fxIn'), { type:'chars' })
    this.FX.textOut = new SplitText(this.DOM.button.querySelector('.fxOut'), { type:'chars' })
    this.prepareTexts()

    setTimeout(() => {
      this.calculate()
      this.close()
    }, 200);
    setTimeout(() => {
      this._fx()
    }, 1000);

    this.events()
  }

  _fx()
  {
    this.animate()
    this.reveal()
  }

  animate()
  {
    this.animation = gsap.timeline({
      scrollTrigger:{
        trigger:this.DOM.view,
        start:'top 100%',
        markers:false
      }
    })

    this.animation.add([
      gsap.fromTo(
        this.DOM.separatorTitle,
        {
          scaleX:0,
          transformOrigin:'left top'
        },
        {
          scaleX:1,
          ease:easesCustom.quart,
          duration:.8,
          onComplete:()=>{
            this.update()
          }
        }
      ),
      gsap.fromTo(
        this.DOM.text,
        {
          autoAlpha:0
        },
        {
          autoAlpha:1,
          ease:easesCustom.cubic,
          duration:.7
        }
      ),
      gsap.fromTo(
        this.FX.textIn.chars,
        {
          y:'100%'
        },
        {
          onStart:()=>{
            gsap.set(this.FX.textOut.chars, { y: '100%' })
          },
          y:0,
          ease:easesCustom.quart,
          duration:.7,
          stagger:.01
        }
      )
    ])
  }

  calculate()
  {
    this.VARS.coords = this.DOM.view.getBoundingClientRect()
    this.VARS.heightOpen = this.VARS.coords.height

  }

  close()
  {
    this.VARS.IS_OPENED = false
    gsap.to(
      this.DOM.view,
      {
        height:this.VARS.heightClose,
        duration:.6,
        ease:easesCustom.quart,
        onComplete:()=>{
          this.update()
        }

      }
    )
  }

  events()
  {
    this.DOM.button.addEventListener('click',()=>{
      this.VARS.status = !this.VARS.status
      this.toggle()
    })

    if(Env.mobileCSS == false) {
      this.DOM.button.addEventListener('mouseenter',()=>{
        if(this.VARS.IS_OPENED == false) {
          this.hover()
        }
      })
      this.DOM.button.addEventListener('mouseleave',()=>{
        if(this.VARS.IS_OPENED == false) {
          this.leave()
        }

      })
    }
  }

  hover()
  {
    gsap.fromTo(
      this.FX.textIn.chars,
      {
        y:0
      },
      {
        y:'-100%',
        ease:easesCustom.quart,
        duration:.7,
        stagger:.01
      }
    )
    gsap.fromTo(
      this.FX.textOut.chars,
      {
        y:'100%'
      },
      {
        y:0,
        ease:easesCustom.quart,
        duration:.7,
        stagger:.01
      }
    )
  }

  leave()
  {
    gsap.to(
      this.FX.textIn.chars,
      {
        y:0,
        ease:easesCustom.quart,
        duration:.7,
        stagger:.01
      }
    )
    gsap.to(
      this.FX.textOut.chars,
      {
        y:'100%',
        ease:easesCustom.quart,
        duration:.7,
        stagger:.01
      }
    )
  }

  open()
  {
    this.tweenOpen = gsap.timeline()
    this.VARS.IS_OPENED = true
    this.tweenOpen
    .add([
      gsap.to(
        this.DOM.view,
        {
          height:this.VARS.heightOpen,
          duration:.6,
          ease:easesCustom.quart,
          onComplete:()=>{
            this.update()
          }
        }
      )
    ])
    .add([
      gsap.fromTo(
        this.DOM.desc,
        {
          autoAlpha:0
        },
        {
          autoAlpha:1,
          duration:.6,
          ease:'cubic.out',
        }
      ),
      gsap.fromTo(
        this.DOM.separatorH,
        {
          scaleX:0,
          transformOrigin:'left top'
        },
        {
          scaleX:1,
          ease:easesCustom.quart,
          duration:.8,
          stagger:.1
        }
      ),
    ])
    .add([
      gsap.fromTo(
        this.DOM.separatorV,
        {
          scaleY:0,
          transformOrigin:'left top'
        },
        {
          scaleY:1,
          ease:easesCustom.quart,
          duration:.8,
          stagger:.1
        }
      ),
      gsap.fromTo(
        this.DOM.fade,
        {
          autoAlpha:0,
        },
        {
          autoAlpha:1,
          ease:'cubic.inOut',
          duration:1
        }
      ),
      gsap.fromTo(
        this.DOM.view.querySelector('.splide__arrows'),
        {
          autoAlpha:0,
        },
        {
          autoAlpha:1,
          ease:'cubic.out',
          duration:.5,
          delay:.5
        }
      )
    ],'-=.4')

  }

  prepareTexts()
  {
    gsap.set(this.FX.textIn.chars,{ y:'100%' })
    gsap.set(this.FX.textOut.chars,{ y:'100%' })
  }

  reveal()
  {
    this.st = ScrollTrigger.create({
      animation:this.animation,
      trigger:this.DOM.view,
      start:'top 80%',
    })
  }

  toggle()
  {
    if(this.VARS.status) {
      this.open()
    } else {
      this.close()
    }
  }


  update()
  {
    if(typeof this.st != 'undefined') {
      this.st.refresh()
    }

    setTimeout(() => {
      Channels.emit('grid::update')
    }, 500);
  }

  unmount()
  {
    this.st.kill(true)
  }
}
